/* tslint:disable:indent */
// Angular
import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {WhmcsClient, WhmcsClientDetails} from '../../../../models/whmcs-client.model';

@Component({
	selector: 'app-dialog-client-details',
	templateUrl: './dialog-client-details.component.html'
})
export class DialogClientDetailsComponent implements OnInit {

	constructor(
		public dialogRef: MatDialogRef<DialogClientDetailsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: {
			basic: WhmcsClient,
			extra: WhmcsClientDetails
		}
	) { }

	ngOnInit() {
	}

	onOkClick(): void {
		this.dialogRef.close(-1);
	}

}
